import React, { useEffect, useState } from 'react';
import { View, TouchableOpacity, StyleSheet } from 'react-native';
import { useNavigation } from '@react-navigation/native';
import { Modals } from '../../../constants/ScreenNames';
import { Color } from '../../../styles';
import Icon from '../../Icon';
import { userTypes } from '../../../constants/Enums';
import EventItem from './EventItem';

const EventList = ({ userType, events = {} }) => {
  const navigation = useNavigation();
  const [showEditScreen, setshowEditScreen] = useState(false);

  useEffect(() => {
    if (events !== undefined) {
      setshowEditScreen(false);
      Object.keys(events).map((date) => {
        events[date].filter((event) => {
          if (event.notEditable !== true) {
            setshowEditScreen(true);
            return;
          }
        });
      });
    }
  }, [events]);

  return (
    <View>
      {userTypes.OWNER === userType && showEditScreen ? (
        <TouchableOpacity
          style={styles.editButton}
          onPress={() => {
            navigation.navigate(Modals.MeetingModal);
          }}
        >
          <Icon name="edit" size={18} color={Color.primary} />
        </TouchableOpacity>
      ) : null}
      {events &&
        Object.keys(events).map((date, index) => (
          <EventItem
            key={date}
            isLast={index === Object.keys(events).length - 1}
            item={{ day: date, activities: events[date] }}
          />
        ))}
    </View>
  );
};

const styles = StyleSheet.create({
  editButton: {
    position: 'absolute',
    right: 12,
    zIndex: 3,
  },
});

export default EventList;
